import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@heroui/react'

export const AdminLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleBackToMain = () => {
    navigate('/')
  }

  const handleBackToAdminDashboard = () => {
    navigate('/admin')
  }

  // Check if we're on the main admin dashboard
  const isMainDashboard = location.pathname === '/admin'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <div className="container mx-auto p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Button
            variant="light"
            onPress={
              isMainDashboard ? handleBackToMain : handleBackToAdminDashboard
            }
            className="shrink-0"
          >
            ← {isMainDashboard ? 'Back to App' : 'Back to Dashboard'}
          </Button>
          <div className="flex items-center gap-3">
            <div>
              <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">
                {isMainDashboard ? 'Admin Dashboard' : 'Admin Panel'}
              </h1>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <Outlet />
      </div>
    </div>
  )
}
